import Api from './Api'
import DistributionGoal from './DistributionGoal'
import Inventory from './Inventory'
import SpecialPackage from './SpecialPackage'
import Model from './interface/Model'

export default class MediaPackage extends Model {
  protected api_settings = {
    save_mode: 'form',
    paths: {
      singular: 'media_package' as string | null,
      plural: 'media_packages' as string | null,
    },
  }

  public name: string = ''

  public program_name: string = ''

  public status: string = 'active'

  public description: string = ''

  public image: string | null = null

  public file: any = null

  public overwrite_rate: boolean = false

  public is_offline: boolean = false

  public rate: number = 45

  public adunit_ids: string[] = []

  public exclude_adunit_ids: string[] = []

  public distribution_goals: DistributionGoal[] = []

  public metrics: any = {}

  public special_packages: SpecialPackage[] = []

  public confirmed_update: boolean = false

  public get adunits(): Array<Inventory> {
    if (!this.adunit_ids) return []
    return Inventory.filter(this.adunit_ids)
  }

  public set adunits(adunits: Array<Inventory>) {
    Inventory.toObjectList(adunits)
  }

  public get exclude_adunits(): Array<Inventory> {
    if (!this.exclude_adunit_ids) return []
    return Inventory.filter(this.exclude_adunit_ids)
  }

  public set exclude_adunits(exclude_adunits: Array<Inventory>) {
    Inventory.toObjectList(exclude_adunits)
  }

  public get apiData() {
    return {
      name: this.name,
      program_name: this.program_name,
      status: this.status,
      description: this.description,
      image: this.image,
      file: this.file,
      overwrite_rate: this.overwrite_rate,
      is_offline: this.is_offline,
      rate: this.rate,
      adunit_ids: this.adunit_ids,
      exclude_adunit_ids: this.exclude_adunit_ids,
      distribution_goals: this.distribution_goals,
      special_packages: this.special_packages,
      confirmed_update: this.confirmed_update,
    }
  }

  /**
   * UI Form Fields
   */
  public get formName(): string {
    return this.name !== '' ? this.name : 'Untitled Media Package'
  }

  constructor(source: any = {}) {
    super()

    Object.assign(this, source)

    if (source.adunits) {
      this.adunits = Inventory.toObjectList(source.adunits)
    }

    if (source.exclude_adunits) {
      this.exclude_adunits = Inventory.toObjectList(source.exclude_adunits)
    }

    return this
  }

  public get status_color(): string {
    if (this.status === 'active') {
      return 'success'
    }
    if (this.status === 'inactive') {
      return 'danger'
    }
    return 'warning'
  }

  public deactivate() {
    this.status = 'inactive'

    return this.save()
  }

  public activate() {
    this.status = 'active'

    return this.save()
  }

  public batchUpdate(selected_ids: any, payload: any, overwrite: any) {
    const api = new Api()
    return api.post('media_packages/batch_update', {
      payload,
      overwrite,
      selected_ids,
    })
  }

  public static async checkPackageUsage(media_package_id: any) {
    const api = new Api()
    return api
      .get(`media_packages/check-usage/${media_package_id}`)
      .then((response: any) => response.data)
  }
}
